import { render, staticRenderFns } from "./PersonalSecondary.vue?vue&type=template&id=13ba099f&"
import script from "./PersonalSecondary.vue?vue&type=script&lang=js&"
export * from "./PersonalSecondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports